import type { Vehicle } from "@/domain/models/vehicle";

/** DTO del microservicio — ajustar cuando exista OpenAPI. */
export type VehicleDto = Vehicle;

export function mapVehicleDto(dto: VehicleDto): Vehicle {
  return {
    id: String(dto.id),
    brand: dto.brand,
    model: dto.model,
    year: Number(dto.year),
    price: Number(dto.price),
    mileage: Number(dto.mileage),
    transmission: dto.transmission,
    fuel: dto.fuel,
    body: dto.body,
    condition: dto.condition,
    available: Boolean(dto.available),
    power: Number(dto.power),
    acceleration: Number(dto.acceleration),
    topSpeed: Number(dto.topSpeed),
    drivetrain: dto.drivetrain,
    color: dto.color,
    image: dto.image,
    gallery: Array.isArray(dto.gallery) ? dto.gallery.map(String) : [],
    features: Array.isArray(dto.features) ? dto.features.map(String) : [],
    description: dto.description,
    tag: dto.tag,
  };
}
